import { useMutation } from "react-query";
import verifyOTP from "../services/verifyOTP";

function useOtpMutation() {
  return useMutation(["VerifyOtp"], verifyOTP);
}

export default useOtpMutation;
